export const handleTrackingEventContentTypePage = $content => {
  $content?.addEventListener('click', event => {
    const $target = event.target;

    const $buttonMore = $target.closest('.js-button-more');

    if ($buttonMore) {
      const $recipeEmbed = $target.closest('.js-recipe-embed');

      $buttonMore.classList.add('js-hidden-button');
      $recipeEmbed.querySelector('.js-hidden-block').classList.remove('js-hidden-block');
    }
  });
};
